import { useFormState } from "../Hooks/useFormState";
import { Badge } from "@/components/catalyst/badge";

export function FormationUnsavedChangesBadge() {
  const { hasUnsavedChanges } = useFormState();

  if (!hasUnsavedChanges) return null;

  return (
    <Badge color="yellow" className="h-fit shrink-0 whitespace-nowrap">
      Unsaved changes
    </Badge>
  );
}
